import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { RadioGroup, FormControlLabel } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import { useTranslation } from 'react-i18next';
import { FacebookTagType, PlatformType } from '../../app/types';
import { setData } from '../../features/mainSlice';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: '33px',
      '& > p': {
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: color.$13,
        margin: '6px 0',
      },
      '& a': {
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        display: 'inline',
        color: color.$2,
      },
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 6,
    },
    icon: {
      margin: '0 0 0 4px',
      '& img': {
        display: 'block',
        '&:hover': {
          opacity: '0.6',
        },
      },
    },
    item: {
      marginRight: 24,
      '&:last-child': {
        margin: 0,
      },
    },
  }),
  {
    name: 'FacebookTag',
  },
);

function FacebookTag() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { fbTag, platform } = useSelector(state => state.ma?.data);

  const handleOnChange = event => {
    dispatch(
      setData({
        fbTag: event.target.value,
      }),
    );
  };

  if (platform === PlatformType.FACEBOOK || platform === PlatformType.INSTAGRAM)
    return (
      <div className={classes.root}>
        <div className={classes.title}>{t(`${platform}-tag-title`)}</div>
        <p>
          {t(`${platform}-tag-description`)}
          <a
            href={t('facebook-tag-helpUrl')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`facebook-tag-reference`)}
          </a>
        </p>
        <RadioGroup row value={fbTag} onChange={handleOnChange}>
          <FormControlLabel
            className={classes.item}
            value={FacebookTagType.NO_TAG}
            control={<Radio color="primary" />}
            label={t(`facebook-tag.${FacebookTagType.NO_TAG}`)}
          />
          <FormControlLabel
            className={classes.item}
            value={FacebookTagType.CONFIRMED_EVENT_UPDATE}
            control={<Radio color="primary" />}
            label={t(`facebook-tag.${FacebookTagType.CONFIRMED_EVENT_UPDATE}`)}
          />
          <FormControlLabel
            className={classes.item}
            value={FacebookTagType.POST_PURCHASE_UPDATE}
            control={<Radio color="primary" />}
            label={t(`facebook-tag.${FacebookTagType.POST_PURCHASE_UPDATE}`)}
          />
          <FormControlLabel
            className={classes.item}
            value={FacebookTagType.ACCOUNT_UPDATE}
            control={<Radio color="primary" />}
            label={t(`facebook-tag.${FacebookTagType.ACCOUNT_UPDATE}`)}
          />
        </RadioGroup>
      </div>
    );
  return null;
}

export default FacebookTag;
